<template>
    <v-stepper v-if="stages.length" alt-labels class="stepper">
        <v-stepper-header  @click.capture="goToAssignment()" >
            <v-stepper-step
                :rules="completedStages[0] === 3 ? problemOnStage : []"
                :step="stages[0].charAt(0)"
                :complete="completedStages[0] === 1"
            >
                {{ stages[0] }}
            </v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step
                :rules="completedStages[1] === 3 ? problemOnStage : []"
                :step="stages[1].charAt(0)"
                :complete="completedStages[1] === 1"
            >
                {{ stages[1] }}
            </v-stepper-step>

            <v-divider v-if="stages[2]"></v-divider>

            <v-stepper-step
                v-if="stages[2]"
                :rules="completedStages[2] === 3 ? problemOnStage : []"
                :step="stages[2].charAt(0)"
                :complete="completedStages[2] === 1">
                {{ stages[2] }}
            </v-stepper-step>

            <v-divider v-if="stages[3]"></v-divider>
            <v-stepper-step
                v-if="stages[3]"
                :rules="completedStages[3] === 3 ? problemOnStage : []"
                :step="stages[3].charAt(0)"
                :complete="completedStages[3] === 1">
                {{ stages[3] }}
            </v-stepper-step>

            <v-divider v-if="stages[4]"></v-divider>
            <v-stepper-step
                v-if="stages[4]"
                :rules="completedStages[4] === 3 ? problemOnStage : []"
                :step="stages[4].charAt(0)"
                :complete="completedStages[4] === 1">
                {{ stages[4] }}
            </v-stepper-step>
            <v-divider v-if="stages[5]"></v-divider>
            <v-stepper-step
                v-if="stages[5]"
                :rules="completedStages[5] === 3 ? problemOnStage : []"
                :step="stages[5].charAt(0)"
                :complete="completedStages[5] === 1">
                {{ stages[5] }}
            </v-stepper-step>
            <v-divider v-if="stages[6]"></v-divider>
            <v-stepper-step
                v-if="stages[6]"
                :rules="completedStages[6] === 3 ? problemOnStage : []"
                :step="stages[6].charAt(0)"
                :complete="completedStages[6] === 1">
                {{ stages[6] }}
            </v-stepper-step>
        </v-stepper-header>
    </v-stepper>
</template>
<script>
    export default {
        props: {
            assignment: {
                type: Object
            }
        },
        computed: {
            assignmentType() {
                return this.assignment.type
            },
            is6digitAssignmentSR() {
                return this.assignment.sr?.length === 6
            },
            config() {
                return this.$store.getters.getConfig || {}
            }
        },
        data: () => {
            return {
                completedStages: [0, 0, 0, 0, 0, 0, 0],
                stages: [],
                type: null,
                problemOnStage: [() => false]
            }
        },
        mounted() {
            this.getStepsBasedOnProgress()
        },
        methods: {
            goToAssignment() {
                this.$router.push(`/assignments/${this.assignment.id}/edit?tab=assignment`)
            },
            getStepsBasedOnProgress() {
                switch (this.assignmentType) {
                case 'PILOT': this.casePilot(); break
                case 'PILOT_UFBB': this.casePilot(); break
                case 'LAST_DROP': this.caseLastDrop(); break
                case 'MALFUNCTION': this.caseMalfunction(); break
                }
            },
            caseMalfunction() {
                this.stages = this.config?.stagesPerAssignmentType[this.assignmentType]?.filter(stage => stage.value !== 'backOffice')?.map(stage => stage.name) || []
                this.completedStages = Array(this.stages.length).fill(0)
                if (this.assignment.earthwork && this.assignment.earthwork.status === 'COMPLETED') {
                    this.completedStages[0] = 1
                } else if (this.assignment.earthwork && this.assignment.earthwork.status !== 'COMPLETED') {
                    this.completedStages[0] = 3
                }
                if (this.assignment.blowing && this.assignment.blowing.status === 'COMPLETED') {
                    this.completedStages[1] = 1
                } else if (this.assignment.blowing) {
                    this.completedStages[1] = 3
                }
                if (this.assignment.construction && this.assignment.construction.status === 'COMPLETED') {
                    this.completedStages[2] = 1
                } else if (this.assignment.construction) {
                    this.completedStages[2] = 3
                }
                if (this.assignment.welding && this.assignment.welding.status === 'COMPLETED') {
                    this.completedStages[3] = 1
                } else if (this.assignment.welding) {
                    this.completedStages[3] = 3
                }
            },
            caseLastDrop() {
                this.stages = this.config?.stagesPerAssignmentType[this.assignmentType]?.filter(stage => stage.value !== 'backOffice')?.map(stage => stage.name) || []
                this.completedStages = Array(this.stages.length).fill(0)
                if (this.assignment.oto && this.assignment.oto.status === 'COMPLETED') {
                    this.completedStages[0] = 1
                } else if (this.assignment.oto && !this.assignment.oto.status === 'COMPLETED') {
                    this.completedStages[0] = 3
                }
                if (this.assignment.activation && this.assignment.activation.status === 'COMPLETED') {
                    this.completedStages[1] = 1
                } else if (this.assignment.activation && this.assignment.activation.status !== 'COMPLETED') {
                    this.completedStages[1] = 3
                }
            },
            casePilot() {
                this.stages = this.config?.stagesPerAssignmentType[this.assignmentType]?.filter(stage => stage.value !== 'backOffice')?.map(stage => stage.name) || []

                if (!this.is6digitAssignmentSR) {
                    this.completedStages = Array(this.stages.length).fill(0)
                } else {
                    this.stages = this.stages.slice(0, -2)
                    this.completedStages = this.completedStages.slice(0, -2)
                }
                if (this.assignment.autopsy && this.assignment.autopsy.status === 'COMPLETED' && (this.assignment.autopsy.nextStepsAt || this.assignment.notFromImport)) {
                    this.completedStages[0] = 1
                } else if (this.assignment.autopsy) {
                    this.completedStages[0] = 3
                }
                if (this.assignment.earthwork && this.assignment.earthwork.status === 'COMPLETED') {
                    this.completedStages[1] = 1
                } else if (this.assignment.earthwork && this.assignment.earthwork.status !== 'COMPLETED') {
                    this.completedStages[1] = 3
                }
                if (this.assignment.blowing && this.assignment.blowing.status === 'COMPLETED') {
                    this.completedStages[2] = 1
                } else if (this.assignment.blowing) {
                    this.completedStages[2] = 3
                }
                if (this.assignment.construction && this.assignment.construction.status === 'COMPLETED') {
                    this.completedStages[3] = 1
                } else if (this.assignment.construction) {
                    this.completedStages[3] = 3
                }
                if (this.assignment.welding && this.assignment.welding.status === 'COMPLETED') {
                    this.completedStages[4] = 1
                } else if (this.assignment.welding) {
                    this.completedStages[4] = 3
                }
                if (!this.is6digitAssignmentSR) {
                    if (this.assignment.oto && this.assignment.oto.status === 'COMPLETED') {
                        this.completedStages[5] = 1
                    } else if (this.assignment.oto) {
                        this.completedStages[5] = 3
                    }
                    if (this.assignment.activation && this.assignment.activation.status === 'COMPLETED') {
                        this.completedStages[6] = 1
                    } else if (this.assignment.activation && this.assignment.activation.status !== 'COMPLETED') {
                        this.completedStages[6] = 3
                    }
                }
            }
        }
    }
</script>

<style scoped>
.test {
    display: block;
}
.stepper {
    box-shadow: none !important;
    background: inherit;
}
.v-divider {
    background: var(--cards-and-tables-text-color) !important;
}

</style>
<style>
.v-stepper__label {
    text-align: center !important;
}
@media only screen and (max-width: 959.98px) {
  .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
    display: block !important;
  }
}

@media only screen and (max-width: 770px) {
  .v-stepper:not(.v-stepper--vertical) .v-stepper__label {
    display: none !important;
  }
}

@media only screen and (max-width: 517px) {
  .stepper {
    display: none !important;
  }
}

.v-stepper__label {
    color: var(--cards-and-tables-text-color) !important;
}
</style>
